<template>
    <b-modal size="lg" ref="createNewItemModal" hide-footer :title="$t(`risk.modal_title_editcountry`)">
        <b-container>
            <b-row>
                <b-col>
                    <b-form-group :label="$t(`sectormodal.sector_code_nace`)" label-for="sector_code_nace">
                        <b-form-input id="sector_code_nace" type="text" :state="!$v.currentItem.sector_code_nace.$error ? null : false" v-model="currentItem.sector_code_nace" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group :label="$t(`sectormodal.sector_name`)" label-for="sector_name">
                        <b-form-input id="sector_name" type="text" v-model="currentItem.sector_name" style="background-color: #fdfdfd"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
        <b-button class="mt-3" variant="primary" block @click="createItem">{{ $t("risk.btn_safe") }}</b-button>
    </b-modal>
</template>
    <script>
    import SectorService from '../../../../../services/Riskmanagement/SectorService';
    import { helpers, required } from 'vuelidate/lib/validators';
    export default {
        name: 'sector-modal',
        props: ['savedCallback'],
        data() {
            return {
                currentItemEditMode: false,
                currentItem: {}
            }
        },
        validations: {
            currentItem: {
                sector_code_nace:   {required},
                sector_name:       {required},
            }
        },
        methods: {
            enterEditMode() {
                this.currentItemEditMode = true;
            },
            leaveEditMode() {
                this.currentItemEditMode = false;
            },
            showModal() {
                this.$v.$reset();
                this.currentItemEditMode = false;
                this.$refs.createNewItemModal.show();
            },
            hideModal() {
                this.$refs.createNewItemModal.hide();
                this.currentItem = {};
                this.$v.$reset();
            },
            setItem(Item) {
                this.currentItem = Item;
            },
            createItem() {
                this.$v.$touch();

                if(this.$v.$error) {
                    return;
                }

                this.$store.commit('loading/setLoading', true);

                if(!this.currentItemEditMode) {
                    SectorService.create(this.currentItem)
                        .then(response => {
                            this.$notify({
                                group: 'global',
                                title: this.$t("risk.notify_success_title_sector"),
                                type: 'success',
                                text: this.$t("risk.notify_success_message_sector")
                            });

                            this.$store.commit('loading/setLoading', false);

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("risk.notify_error_title_sector"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }else {
                    SectorService.update(this.currentItem.id, this.currentItem)
                        .then(response => {
                            this.$notify({
                                    group: 'global',
                                title: this.$t("risk.notify_correction_title_sector"),
                                    type: 'success',
                                text: this.$t("risk.notify_correction_message_sector")
                                });

                            if(this.savedCallback){
                                this.savedCallback();
                            }

                            this.$refs.createNewItemModal.hide();
                            this.currentItem = {};
                        })
                        .catch(error => {
                            this.$store.commit('loading/setLoading', false);
                            this.$notify({
                                group: 'global',
                                title: this.$t("risk.notify_correction_error_sector"),
                                type: 'error',
                                text: error.message
                            });
                        });
                }
            }
        }
    }
    </script>
